import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ktcqb4hfg7: FaireBrandEntity = {
  token: "b_ktcqb4hfg7",
  type: "brand",
  name: "L&F Universal Goods",
  avatarUrl:
    "https://cdn.faire.com/fastly/354398b6b16d277020b629282abb52b0104f0661d93cf1fa28412852f8eb5986.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/797649e4b97f33664249eda43396590494078cff72d3b765279c9b3f08ab1bc0.png",
  logoUrl:
    "https://cdn.faire.com/fastly/354398b6b16d277020b629282abb52b0104f0661d93cf1fa28412852f8eb5986.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/797649e4b97f33664249eda43396590494078cff72d3b765279c9b3f08ab1bc0.png",
  location: "Miami, FL, USA",
  minimumOrderDollars: 208,
  rating: 3.8,
  reviewCount: 66,
  isTopShop: true,
  isInsider: true,
  description:
    "Savor the moment with irresistible snacks and refreshing beverages. 🍿🥤 Join us on a tasty adventure. 🌟",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:43.572Z",
    importedBy: "entity-db-cli",
  },
};
